import React from "react";
import Input from "../../../../Components/UI/Input";
import { useFormContext } from "react-hook-form";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const salaryTypes = [
  { label: "Monthly", value: "Monthly" },
  // { label: "Daily", value: "Daily" },
  { label: "Hourly", value: "Hourly" },
];

const option_2 = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const SalaryBlock = () => {
  const {
    register,
    formState: { errors },
    watch,
    trigger,
    setValue,
    getValues,
    clearErrors,
  } = useFormContext();

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <div className="form-row row">
            <div className="col-md-12 mb-3">
              <Input
                name="salaryType"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.salaryType ? "is-invalid" : ""
                }`}
                label="Salary Type"
                labelClassName="form-label"
                optionData={salaryTypes}
                required={true}
                requiredMessage="Salary Type is required"
                onSelect={(selectedOption) => {
                  setValue(
                    "salaryType",
                    selectedOption ? selectedOption : null,
                  );
                  setValue("basicSalary", 0);
                  setValue("hourlySalary", 0);
                  setValue("daySalary", 0);
                  trigger("salaryType");
                  trigger("basicSalary");
                  trigger("hourlySalary");
                  trigger("daySalary");
                }}
                defaultValue={watch("salaryType")}
              />
            </div>

            {getValues("salaryType") === "Monthly" && (
              <div className="col-md-12 mb-3">
                <Input
                  name="basicSalary"
                  type="text"
                  placeholder="Monthly Salary"
                  className={`form-control ${
                    errors.basicSalary ? "is-invalid" : ""
                  }`}
                  label="Monthly Salary"
                  labelClassName="form-label"
                  required={true}
                  requiredMessage="Basic Pay is required"
                  value={watch("basicSalary")}
                />
              </div>
            )}

            {/* <div className="col-md-12 mb-3">
              <Input
                name="daySalary"
                type="text"
                placeholder="Day Salary"
                className={`form-control ${
                  errors.daySalary ? "is-invalid" : ""
                }`}
                label="Day Salary"
                labelClassName="form-label"
                required={false}
                requiredMessage="Day Salary is required"
              />
            </div> */}

            {getValues("salaryType") === "Hourly" && (
              <div className="col-md-12 mb-3">
                <Input
                  name="hourlySalary"
                  type="text"
                  placeholder=""
                  className={`form-control ${
                    errors.hourlySalary ? "is-invalid" : ""
                  }`}
                  label="Hourly Salary"
                  labelClassName="form-label"
                  required={true}
                  requiredMessage="Hourly Salary is required"
                  value={watch("hourlySalary")}
                />
              </div>
            )}

            <div className="col-md-12 mb-3">
              <Input
                name="haveFullPay"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.haveFullPay ? "is-invalid" : ""
                }`}
                label="Have Full Pay"
                labelClassName="form-label"
                optionData={option_2}
                required={false}
                requiredMessage="Have Full Pay is required"
                onChange={(selectedOption) => {
                  setValue("haveFullPay", selectedOption);
                  trigger("haveFullPay");
                }}
                defaultValue={watch("haveFullPay")}
              />
            </div>

            <div className="col-md-12 mb-3">
              <Input
                name="haveLessTimeDeduction"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.haveLessTimeDeduction ? "is-invalid" : ""
                }`}
                label="Have Less Time Deduction"
                labelClassName="form-label"
                optionData={option_2}
                required={false}
                requiredMessage="Have Less Time Deduction is required"
                onChange={(selectedOption) => {
                  setValue("haveLessTimeDeduction", selectedOption);
                  trigger("haveLessTimeDeduction");
                }}
                defaultValue={watch("haveLessTimeDeduction")}
              />
            </div>

            <div className="col-md-12 mb-3">
              <Input
                name="haveOverTimePay"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.haveOverTimePay ? "is-invalid" : ""
                }`}
                label="Have Overtime Pay (OT Day)"
                labelClassName="form-label"
                optionData={option_2}
                required={false}
                requiredMessage="Have Overtime Pay is required"
                onChange={(selectedOption) => {
                  setValue("haveOverTimePay", selectedOption);
                  trigger("haveOverTimePay");
                }}
                defaultValue={watch("haveOverTimePay")}
              />
            </div>

            <div className="col-md-12 mb-3">
              <Input
                name="haveOverTimePayForExtraHours"
                type="commonSelect"
                placeholder=""
                className={`form-control ${
                  errors.haveOverTimePayForExtraHours ? "is-invalid" : ""
                }`}
                label="Have Overtime Pay (OT Hour)"
                labelClassName="form-label"
                optionData={option_2}
                required={false}
                requiredMessage="Have Overtime Pay is required"
                onChange={(selectedOption) => {
                  setValue("haveOverTimePayForExtraHours", selectedOption);
                  trigger("haveOverTimePayForExtraHours");
                }}
                defaultValue={watch("haveOverTimePayForExtraHours")}
              />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-row row">
            {getValues("salaryType") === "Monthly" && (
              <>
                <div className="col-md-12 mb-3">
                  <Input
                    name="otDaySalary"
                    type="text"
                    placeholder=""
                    className={`form-control ${
                      errors.otDaySalary ? "is-invalid" : ""
                    }`}
                    label="Fixed Day Salary"
                    labelClassName="form-label"
                    optionData={option_2}
                    required={false}
                    requiredMessage="Extra Hours Rate is required"
                    // onChange={(selectedOption) => {
                    //   setValue("extraHoursRate", selectedOption);
                    //   trigger("extraHoursRate");
                    // }}
                    defaultValue={watch("otDaySalary")}
                    // info="Premium OT Hours"
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <Input
                    name="otHourlySalary"
                    type="text"
                    placeholder=""
                    className={`form-control ${
                      errors.otHourlySalary ? "is-invalid" : ""
                    }`}
                    label="Fixed Hourly Salary"
                    labelClassName="form-label"
                    optionData={option_2}
                    required={false}
                    requiredMessage="Extra Hours Rate is required"
                    // onChange={(selectedOption) => {
                    //   setValue("extraHoursRate", selectedOption);
                    //   trigger("extraHoursRate");
                    // }}
                    defaultValue={watch("otHourlySalary")}
                    // info="Premium OT Hours"
                  />
                </div>
              </>
            )}

            <div className="col-md-12 mb-3">
              <Input
                name="extraHoursRate"
                type="text"
                placeholder=""
                className={`form-control ${
                  errors.extraHoursRate ? "is-invalid" : ""
                }`}
                label="Extra Hours Rate"
                labelClassName="form-label"
                optionData={option_2}
                required={true}
                requiredMessage="Extra Hours Rate is required"
                // onChange={(selectedOption) => {
                //   setValue("extraHoursRate", selectedOption);
                //   trigger("extraHoursRate");
                // }}
                defaultValue={watch("extraHoursRate")}
                info="Premium OT Hours"
              />
            </div>

            <div className="col-md-12 mb-3">
              <Input
                name="oT1PayRate"
                type="text"
                placeholder="OT1 Pay Rate"
                className={`form-control ${
                  errors.oT1PayRate ? "is-invalid" : ""
                }`}
                label="OT1 Pay Rate"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT1 Pay Rate is required"
                info="Normal Working Day OT Hours"
              />
            </div>
            <div className="col-md-12 mb-3">
              <Input
                name="oT2PayRate"
                type="text"
                placeholder="OT2 Pay Rate"
                className={`form-control ${
                  errors.oT2PayRate ? "is-invalid" : ""
                }`}
                label="OT2 Pay Rate"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT2 Pay Rate is required"
                info="Rest Day / Public Holiday OT Hours"
              />
            </div>
            <div className="col-md-12 mb-3">
              <Input
                name="oT3PayRate"
                type="text"
                placeholder="OT3 Pay Rate"
                className={`form-control ${
                  errors.oT3PayRate ? "is-invalid" : ""
                }`}
                label="OT3 Pay Rate"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT3 Pay Rate is required"
                info="Public Holiday Normal Working Hours"
              />
            </div>
            {/* <div className="col-md-12 mb-3">
              <Input
                name="otDaySalary"
                type="text"
                placeholder="OT Day Salary"
                className={`form-control ${
                  errors.otDaySalary ? "is-invalid" : ""
                }`}
                label="OT Day Salary"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT Day Salary is required"
              />
            </div>
            <div className="col-md-12 mb-3">
              <Input
                name="otHourlySalary"
                type="text"
                placeholder="OT Hourly Salary"
                className={`form-control ${
                  errors.otHourlySalary ? "is-invalid" : ""
                }`}
                label="OT Hourly Salary"
                labelClassName="form-label"
                required={false}
                requiredMessage="OT Hourly Salary is required"
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SalaryBlock;
